import React from 'react'
import { Switch, Redirect, Route, withRouter } from 'react-router-dom'
import { PATHS } from 'Config/Routing/paths'
import { authorization } from 'Module/Auth/Auth'

import { ROLE_CLIENT, ROLE_CLIENT_ADMIN } from '../../shared/constants'

import ClientCampaigns from 'Containers/ClientCampaigns'

const ClientCampaignsRouter = props => {
  const {
    match: {
      url,
      path,
      params: { clientId },
    },
  } = props
  const { role, client } = authorization.getUser()

  const isEddmEnabled = client.countryId === 14

  if (
    (role === ROLE_CLIENT || role === ROLE_CLIENT_ADMIN) &&
    client &&
    client.id.toString() !== clientId
  ) {
    if (isEddmEnabled) {
      return (
        <Redirect
          to={`${path.split(':clientId')[0]}${client.id}${
            PATHS.campaignsTypes.active
          }`}
        />
      )
    }
  } else if (isNaN(Number(clientId))) {
    return <Redirect to={`/dashboard`} />
  }

  return (
    <Switch>
      <Route path={[`${url}/:type/:subType`, `${url}/:type`]}>
        <ClientCampaigns
          client={
            client && Object.keys(client).includes('id')
              ? client
              : { ...client, id: clientId }
          }
        />
      </Route>
      <Redirect from={url} to={`${url}${PATHS.campaignsTypes.active}`} />
    </Switch>
  )
}

export default withRouter(ClientCampaignsRouter)
